<template>
		<div class="carousel-box bottom-padding overflow">
			<div class="title-box no-margin" >
			<a class="next" href="#" style="margin-top:10px;">
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				width="9px" height="16px" viewBox="0 0 9 16" enable-background="new 0 0 9 16" xml:space="preserve">
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#fcfcfc" points="1,0.001 0,1.001 7,8 0,14.999 1,15.999 9,8 "/>
				</svg>
			</a>
			<a class="prev" href="#" style="margin-top:10px;">
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				width="9px" height="16px" viewBox="0 0 9 16" enable-background="new 0 0 9 16" xml:space="preserve">
				<polygon fill-rule="evenodd" clip-rule="evenodd" fill="#fcfcfc" points="8,15.999 9,14.999 2,8 9,1.001 8,0.001 0,8 "/>
				</svg>
			</a>
			<h1 class="title">Featured Products</h1>
			</div>
			
			<div class="clearfix"></div>
			
			<div class="row">
				<div  data-carousel-autoplay="true">
					<div class="carousel" v-touch:tap="touchHandler">
				
				
				<a href="javascript:void(0);" :page="result.category_name + '/' + result.page_name" v-for="result in results" :key="result.id" class="span3 product">
				<div class="product-image">
					<img :src="decodeURI(result.image_path)" alt="" title="" :page="result.category_name + '/' + result.page_name">
				</div>
				<div class="product-description" :page="result.category_name + '/' + result.page_name">
					<div class="vertical" :page="result.category_name + '/' + result.page_name">
					<h3 class="product-name">{{result.title}}</h3>
					<div class="price">{{result.category_name}}</div>	
					</div>
				</div>
				</a><!-- .product -->
				</div>
			</div>
			</div>
		</div>
</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'BestSellers',
   data: function(){
    return {
    results: null
    }
  },  props: {
    msg: String
  },mounted: function() {

    Common.callServerFunction("Items/ItemController::GetFeaturedItems",this.get_response,{},"Item");

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },methods:{
          touchHandler (event) {
            
            //var purl =  $(event.target).attr('href');
            //if(purl != undefined)
            //{
            //  this.$router.push(purl);
            //}else
            //{
            //  purl = $(event.target).parent().attr('href');
            //  this.$router.push(purl);
            //}

            var attr = $(event.target).parent().attr('page');

            if (typeof attr !== typeof undefined && attr !== false) {
                  //$(event.target).trigger("click");    
                  this.$router.push('/' + attr);
            }else{
                  //$(event.target).parent().trigger("click");
                  attr = $(event.target).parent().parent().attr('page');
                  this.$router.push('/' + attr);
            }  

            //console.log($(event.target).parent().parent())  // May be left / right / top / bottom
        },
          get_response:function(response)
          {	
            var rdata = JSON.parse(response);
            this.results = rdata;
            
                Common.stopAjaxLoader();
                var jimage = [];
                rdata.forEach((item) => {
                    //console.log(item.image_path + " - " + index);
                    jimage.push(item.image_path)
                });
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                    //(completed, progress) => {
                      (completed) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      //console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        //console.log(completed);
                        eval('loadFunctions();loadSlider();');
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
                Common.stopAjaxLoader();
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
